
import AppCoreCmp from '../components/AppCoreCmp.js';

const { connect } = require('react-redux');

const { getMenu, getIntermediario } = require('../actions/loginAction')

const mapStateToProps = (state) => {
    return {
      menu: state.homeReducer.menu,
      status: state.homeReducer.status,
      loginResponse: state.loginReducer.loginResponse,
      loginStatus: state.loginReducer.loginStatus
    };
};

const mapDispatchToProps = dispatch => ({
  getMenu: (token) => {
    dispatch(getMenu(token));
  },
  getIntermediario: (payload) => {
    dispatch(getIntermediario(payload));
  }
 });

export default connect(mapStateToProps, mapDispatchToProps)(AppCoreCmp);
